<template>
  <div class="-about-page-index">
    <section class="section">
      <div class="container">
        <AppHeadshot />
      </div>
    </section>
  </div>
</template>

<script>
import AppHeadshot from "@/components/pages/about/AppHeadshot.vue";

export default {
  name: "AboutPageIndex",
  components: {
    AppHeadshot
  },
  methods: {
    fadeIn() {
      this.$anime({
        targets: this.$el,
        opacity: ["0%", "100%"],
        duration: 400
      });
    }
  },
  mounted() {
    this.fadeIn();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
